// css =>
import "../../BaseStructure.css";
import Styled from "./SignIn.module.css";

// componenets =>
import Header from "../../Components/header/header.comp";
import MenuBar from "../../Components/menuBar/menuBar.comp";
import InputBox from "../../Components/inputBox/inputBox.comp";
import SelectBox from "../../Components/selectBox/selectBox.comp";
import InputSpace from "../../Components/inputsSpace/inputsSpace.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";

// react =>
import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// services =>
import { SaveToSession, HandleSignInSubmit } from "./SignInService";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

function SignIn() {

    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const [rullsIsChecked, setRullsIsChecked] = useState(false);

    const nameInputRef = useRef<HTMLInputElement>(null);
    const lastNameInputRef = useRef<HTMLInputElement | null>(null);
    const phoneNumberInputRef = useRef<HTMLInputElement | null>(null);
    const genderSelectBoxRef = useRef<HTMLSelectElement | null>(null);
    const emailAddressInputRef = useRef<HTMLInputElement | null>(null);

    const genderOptions = [
        { title: "آقا", value: "MR" },
        { title: "خانم", value: "MRS" },
        { title: "ترجیح میدهم نگویم", value: "NOT" }
    ];

    useEffect(() => {
        document.title = "ایجاد حساب کاربری | ویدوک";

        const saved = sessionStorage.getItem('signInForm');
        if (saved) {
            const data = JSON.parse(saved);
            if (nameInputRef.current) nameInputRef.current.value = data.name || "";
            if (lastNameInputRef.current) lastNameInputRef.current.value = data.lastName || "";
            if (phoneNumberInputRef.current) phoneNumberInputRef.current.value = data.phoneNumber || "";
            if (genderSelectBoxRef.current) genderSelectBoxRef.current.value = data.genderSelectBox || "";
            if (emailAddressInputRef.current) emailAddressInputRef.current.value = data.email || "";
        }
    }, []);

    const handleSubmit = () => {
        HandleSignInSubmit(
            {
                name: nameInputRef,
                lastName: lastNameInputRef,
                phoneNumber: phoneNumberInputRef,
                emailAddress: emailAddressInputRef,
                gender: genderSelectBoxRef,
            },
            rullsIsChecked,
            navigate,
            showMessage,
        );
    };

    return(
        <>
            <Header />
            <MobileMenuBar key={ 0 } isAuthenticated={ false } />

            <div className="row" id={ Styled.SignInHeader }>
                <div className="col-12">
                    <h1>ایجاد حساب کاربری</h1>
                </div>
            </div>

            <div className="row">
                <InputBox inputType="char" placeHolder="اجباری" inputTittle="نام" ref={ nameInputRef } onChange={ () => {
                    SaveToSession(
                        nameInputRef,
                        lastNameInputRef,
                        phoneNumberInputRef,
                        genderSelectBoxRef,
                        emailAddressInputRef,
                    );
                }} />
                <InputBox inputType="char" placeHolder="اجباری" inputTittle="نام خانوادگی" ref={ lastNameInputRef } onChange={ () => {
                    SaveToSession(
                        nameInputRef,
                        lastNameInputRef,
                        phoneNumberInputRef,
                        genderSelectBoxRef,
                        emailAddressInputRef,
                    );
                }} />

                <InputSpace />

                <SelectBox
                    key={ 0 }
                    ref={ genderSelectBoxRef }
                    title="جنسیت"
                    options={ genderOptions }
                />
                <InputBox inputType="tel" maxLenght={11} placeHolder="اجباری" inputTittle="تلفن همراه" defaultValue="09" ref={ phoneNumberInputRef } onChange={ () => {
                    SaveToSession(
                        nameInputRef,
                        lastNameInputRef,
                        phoneNumberInputRef,
                        genderSelectBoxRef,
                        emailAddressInputRef,
                    );
                }} />

                <InputSpace />

                <InputBox inputType="text" inputTittle="ایمیل" placeHolder="اختیاری" ref={ emailAddressInputRef } onChange={ () => {
                    SaveToSession(
                        nameInputRef,
                        lastNameInputRef,
                        phoneNumberInputRef,
                        genderSelectBoxRef,
                        emailAddressInputRef,
                    );
                }} />
            </div>

            <div className="row" id={ Styled.RullsSectionFrame }>
                <br /><br />
                <div className="col-12">
                    <span>شرایط و مقررات را مطالعه کردم و قبول میکنم</span>
                    <input 
                        type="checkbox" 
                        checked={ rullsIsChecked }
                        onChange={(e) => {
                            setRullsIsChecked(e.target.checked);
                        }}
                    />
                </div>

                <div className="col-12">
                    <br />
                    <button id={ Styled.CreateAccountButton } onClick={ handleSubmit }>
                        <h2>دریافت کد تایید</h2>
                    </button>
                    <br /><br />
                </div>

                <div className="col-12">
                    <span>اگر قبلا ثبت نام کرده اید: </span>
                    <a href="/log-in"><span style={{ color: 'blue' }}> ورود به حساب کاربری</span></a>
                </div>
            </div>

            <MenuBar />
        </>
    );
}

export default SignIn;
